import { render, staticRenderFns } from "./NavLangDropdown.vue?vue&type=template&id=5d3e7fc0"
import script from "./NavLangDropdown.vue?vue&type=script&lang=js"
export * from "./NavLangDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports